export default "__VITE_ASSET__CV4MI0mr__"